import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorScreen } from '@account-services-mfe/core';
import PaymentSecurityContextProvider, { defaultState } from './context';
import PaymentSecurity from './ui';
import DefaultProviders from './ui/default-providers';
export const PaymentSecurityRoot = ({ config, selectedAccountId, authorizeAONUrl, handleClose }) => {
    const paymentSecurityGlobalState = {
        ...defaultState,
        config,
        selectedAccountId,
        authorizeAONUrl,
        handleClose
    };
    return (_jsx(DefaultProviders, { config: config, children: _jsx(ErrorBoundary, { fallback: _jsx(ErrorScreen, { id: "payment-security-root-boundary" }), children: _jsx(PaymentSecurityContextProvider, { initialState: paymentSecurityGlobalState, children: _jsx(PaymentSecurity, {}) }) }) }));
};
export default PaymentSecurityRoot;
